<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme
import resize from '@/components/resize'
import { getDateAndHour } from '@/utils/updateTime.js'

export default {
  mixins: [resize],
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    },
    datadetail: {
      type: Array,
      default: () => []
    },
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      // default:''
      default: '100%'
    },
    height: {
      type: String,
      // default:''
      default: '540px'
    }
  },
  data() {
    return {
      chart: null
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons')
      if (this.datadetail.length > 0) {
        var legenddata = []
        var seriesdata = []
        var openObject = {
          name: 'Idle',
          type: 'bar',
          // barWidth: 10,
          barMinHeight: 2,
          data: []
        }; var dischargeObject = {
          name: 'Discharged',
          type: 'bar',
          barMinHeight: 2,
          // barWidth: 20,
          barGap: '-100%', // Make series be overlap
          data: []
        }; var chargeObject = {
          name: 'Charged',
          type: 'bar',
          // barWidth: 50,
          barGap: '-100%', // Make series be overlap
          data: []
        }

        // var tempTimeObiect = {
        //   name: 'BatteryTemp',
        //   type: 'line',
        //   yAxisIndex: 3,
        //   data: []
        // }
        //  var socObject = {
        //   name: 'Soc',
        //   type: 'line',
        //   yAxisIndex: 4,
        //   data: []
        // }
        for (var i in this.datadetail) {
          var idx = this.datadetail[i]
          // legenddata.push(filter.formatTime(idx.startTime))
          // legenddata.push(filter.formatTime(idx.startTime))
          legenddata.push(getDateAndHour(idx.startTime, 'onlyTime'))
          // legenddata.push(idx.startTime)
          // legenddata.push(idx.startTime)
          // tempTimeObiect.data.push(idx.maxTemp)
          // tempTimeObiect.data.push(idx.maxTemp)
          // socObject.data.push(idx.minSoc)
          if (idx.eventType == 'Open') {
            openObject.data.push(idx.ahr / 100)
            dischargeObject.data.push('')

            chargeObject.data.push('')
          } else if (idx.eventType == 'Discharge') {
            openObject.data.push('')
            dischargeObject.data.push(idx.ahr / 100)
            chargeObject.data.push('')
          } else if (idx.eventType == 'Charge') {
            openObject.data.push('')
            dischargeObject.data.push('')
            chargeObject.data.push(idx.ahr / 100)
          }
        }
        // seriesdata=[openObject,dischargeObject,chargeObject,tempTimeObiect,VoltageObject]
        seriesdata.push(openObject)
        seriesdata.push(dischargeObject)
        seriesdata.push(chargeObject)
        // seriesdata.push(tempTimeObiect)
        // seriesdata.push(VoltageObject)
        // console.log(seriesdata)
      }
      var colors = ['rgb(255,140,0)', 'rgb(30,144,255)', '#a9d252', '#ed3e13', '#e46cbb']
      this.chart.setOption({
        color: colors,
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'cross' // 默认为直线，可选为：'line' | 'shadow'
          },
          textStyle: {
            align: 'left'
          }
        },
        // grid: {
        //   top: 50,
        //   left: '2%',
        //   right: '2%',
        //   bottom: '3%',
        //   containLabel: true
        // },

        legend: {
          data: ['Idle', 'Discharged', 'Charged']
        },
        xAxis: [{
          type: 'category',
          data: legenddata,
          // data: ['05:00', '06:15', '07:30', '08:45', '10:00', '11:15', '12:30', '13:45', '15:00', '16:15', '17:30', '18:45', '20:00', '21:15', '22:30', '23:45', '00:00', '01:15', '02:30', '03:45'],
          axisTick: {
            alignWithLabel: true
          }
        }],
        yAxis: [
          {
            type: 'value',
            splitLine: {
              show: true
            },
            axisLabel: {
              formatter: '{value} Ah'
            }
          }

        ],
        series: seriesdata
      })
    }
  }
}
</script>
